import MaterialCommunityIcons from "@react-native-vector-icons/material-design-icons/static";
import { Text } from "react-native-paper";
import { useAppTheme } from "../../../useAppTheme";
import Box from "../../Box";

export type GridCardProps = {
	title?: string;
	isSelected?: boolean;
	children?: React.ReactNode;
	type?: "default" | "selectable";
	padding?: number;
	gap?: number;
};

export const GridCard = ({
	title,
	children,
	type = "default",
	isSelected = false,
	padding = 16,
	gap = 8,
}: GridCardProps) => {
	const theme = useAppTheme();

	if (type === "default") {
		return (
			<Box
				flex={1}
				padding={padding}
				gap={gap}
				borderRadius={theme.roundness * 4}
				justifyContent="center"
				alignItems="center"
				style={{
					backgroundColor: `${theme.colors.inversePrimary}1F`,
					borderColor: `${theme.colors.outlineVariant}1F`,
					borderWidth: 1,
				}}
			>
				<Box alignSelf="center" justifyContent="center" alignItems="center">
					{children}
				</Box>
				{title && (
					<Text
						style={{
							width: "100%",
							textAlign: "center",
							fontSize: 16,
							fontWeight: "500",
							color: theme.colors.primary,
						}}
					>
						{title}
					</Text>
				)}
			</Box>
		);
	}

	const selectedStyle = isSelected
		? {
				backgroundColor: theme.colors.elevation.level5,
				borderColor: theme.colors.outline,
				borderWidth: 2,
			}
		: {
				backgroundColor: theme.colors.elevation.level1,
				borderWidth: 2,
				borderColor: "transparent",
			};

	return (
		<Box
			flex={1}
			padding={padding}
			gap={gap}
			borderRadius={theme.roundness * 4}
			style={selectedStyle}
			justifyContent="center"
		>
			{isSelected && (
				<MaterialCommunityIcons
					style={{
						position: "absolute",
						top: 6,
						right: 6,
						zIndex: 1000,
					}}
					name="checkbox-marked-circle"
					size={16}
					color={theme.colors.primary}
				/>
			)}
			<Box alignSelf="center" justifyContent="center" alignItems="center">
				{children}
			</Box>
			{title && (
				<Text
					style={{
						width: "100%",
						textAlign: "center",
						fontSize: 16,
						fontWeight: "500",
						color: theme.colors.primary,
					}}
				>
					{title}
				</Text>
			)}
		</Box>
	);
};
